import React, { useEffect, useRef, useMemo } from "react";
import Switch from "@mui/material/Switch";
import FormControlLabel from "@mui/material/FormControlLabel";
import "bootstrap/dist/css/bootstrap.css";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { useState } from "react";
import { withRouter } from "react-router";
import Button from "@material-ui/core/Button";
import { updateAlert, updateSourceInputs } from "../../../redux/actions";
import LayoutTopSideBottom from "../../../layouts/LayoutTopSideBottom/LayoutTopSideBottom";
import Breadcrumbs from "../../../components/Breadcrumbs/Breadcrumbs";
import EditableTableAttribute from "./EditableTableAttribute";
import fieldsArr from "../fields";
import MetaSearchFilters from "./MetaSearchFilter";
import "../rociview.scss";

import { config } from "../../../config/config";
import Loader from "../../../components/Loader/Loader";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { useUserAuthentication } from "../../../utils/utils";

import RecommandationModal from "../../../components/modal/recommandModel";
import { useHistory } from "react-router-dom";
import { ApprovalButton } from "../../../components/Approval/ApprovalButton";
import { ApprovalTable } from "../../../components/Approval/ApprovalTable";
import DynamicDialog from "../../../components/Dialog/Dialog";

let api = config.api.api_url;
// let api = process.env.REACT_APP_BACKEND_BASE_URL;

function AttributeEnrichment(props) {
  const { user, match, updateSourceInputs, updateAlert, source_data } = props;

  const getData = (row) => {};

  const [loading, setLoading] = useState(true);
  const [isTableDataSaving, setIsTableDataSaving] = useState(false);
  const [isSaveDialogOpen, setIsSaveDialogOpen] = useState(false);
  const [isBackDialogOpen, setIsBackDialogOpen] = useState(false);
  const [isCancelDialogOpen, setIsCancelDialogOpen] = useState(false);
  const [isApproval, setIsApproval] = useState(false);
  const [isDynamicDialogOpen, setIsDynamicDialogOpen] = useState(false);
  const [dynamicDialogMessage, setDynamicDialogMessage] = useState();
  const [isPlaceholderFetching, setIsPlaceholderFetching] = useState(false);
  const [isFileUploading, setIsFileUploading] = useState(false);
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const [isEdit, setIsEdit] = useState(false);
  const [globalEdit, setGlobalEdit] = useState(false);
  const { login } = useUserAuthentication();
  let history = useHistory();

  const is_Approver = useMemo(() => {
    const Is_Role_Approver = user?.role && user?.role?.includes("AppApprover");
    const URL = history?.location?.pathname || [];
    const result = URL.split("/").pop();
    const is_Approver_For_This_Usecase =
      user?.approval_screens && user?.approval_screens?.includes(result);
    return Is_Role_Approver && is_Approver_For_This_Usecase;
  }, [user.role, user.approval_screens]);

  const IS_ANY_RECORDS_EDITED = useMemo(() => {
    if (source_data.is_file_uploaded) return true;
    if (globalEdit) return true;
    return false;
  }, [
    source_data.current_mapped_data,
    source_data.is_file_uploaded,
    globalEdit,
  ]);

  const has_Awaiting_Data = useMemo(() => {
    const data = source_data?.has_awaiting_data;

    if (!data) return false;

    const { has_records, has_access } = data;

    return !has_records || (has_records && has_access);
  }, [source_data.has_awaiting_data]);

  const can_show_initial_disclaimer = useMemo(() => {
    const Is_Ready =
      has_Awaiting_Data &&
      !isPlaceholderFetching &&
      !isFileUploading &&
      source_data.is_initial &&
      source_data.is_table_loading;

    if (Is_Ready) return true;
    return false;
  }, [
    has_Awaiting_Data,
    isPlaceholderFetching,
    isFileUploading,
    source_data.is_initial,
    source_data.is_table_loading,
  ]);

  async function getSources() {
    try {
      // code for initial data fetching
      const response = await fetch(api + "/attribute_enrichment/getdataset", {
        method: "GET",
        mode: "cors",
        credentials: "include",
        headers: {
          Authorization: `Bearer ${user.token || ""}`,
          "Content-Type": "application/json",
        },
      });

      // Check if response is OK before trying to parse it
      if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        if (errorData?.statusCode === "harbor-401") {
          updateAlert({
            open: true,
            message: `User Unauthorized. Please sign in.`,
            severity: "warning",
            closeFlag: true,
          });
          login(); // or redirect to login
          return;
        } else {
          throw new Error(`Unexpected error occured. Please try again later`);
        }
      }

      const data = await response.json();

      if (!data || !Array.isArray(data.data.dataset) || !data.data) {
        updateAlert({
          open: true,
          message: `Unexpected error occured. Please try again later`,
          severity: "warning",
          closeFlag: true,
        });
        throw new Error("Unexpected error occured. Please try again later");
      }

      const Datasets =
        data?.data?.dataset?.map((item) => {
          return { label: item, value: item };
        }) || [];

      updateSourceInputs("data", data);
      updateSourceInputs("current_mapped_source", Datasets);
      updateSourceInputs("dimensions_list", data.data.dimensions);
    } catch (err) {
      updateAlert({
        open: true,
        message: `Unexpected error occured. Please try again later`,
        severity: "warning",
        closeFlag: true,
      });
    } finally {
      setLoading(false);
    }
  }

  const clearReduxState = () => {
    updateSourceInputs("fulactualdata", []);
    updateSourceInputs("get_recommendation_for_all_rows", false);
    updateSourceInputs("get_recommendation_status", "");
    updateSourceInputs("get_recommendation_error_message", {
      status: false,
      message: "",
    });
    updateSourceInputs("get_recommendation_all_modal_data", []);
    updateSourceInputs("has_awaiting_data", false);
    updateSourceInputs("data", []);
    updateSourceInputs("checked_rows_count", 0);
    updateSourceInputs("current_bussines_unit", "");
    updateSourceInputs("current_dimension", {});
    updateSourceInputs("dimensions_list", []);
    updateSourceInputs("current_source", "");
    updateSourceInputs("current_source_label", "");
    updateSourceInputs("current_target_gold_layer", "");
    updateSourceInputs("current_country", "");
    updateSourceInputs("current_country_code", "");
    updateSourceInputs("current_cmu", "");
    updateSourceInputs("current_category", "");
    updateSourceInputs("current_ssfFileId", "");
    updateSourceInputs("current_filter_value", "");
    updateSourceInputs("current_template_filter_value", "");
    updateSourceInputs("current_template_ssfFileId", "");
    updateSourceInputs("current_table_name", "");
    updateSourceInputs("is_initial", true);
    updateSourceInputs("is_table_loading", true);
    updateSourceInputs("searchValue", "");
    updateSourceInputs("any_row_isEditing", false);
    updateSourceInputs("isFileUploaded", false);
    updateSourceInputs("isNewDataInserted", false);
    updateSourceInputs("current_bussines_unit_list", []);
    updateSourceInputs("current_mapped_source", []);
    updateSourceInputs("current_target_gold_layer_list", []);
    updateSourceInputs("current_mapped_country", []);
    updateSourceInputs("master_table_countries", []);
    updateSourceInputs("current_ssf_file_id", []);
    updateSourceInputs("current_template_ssf_file_id", []);
    updateSourceInputs("current_category_data", []);
    updateSourceInputs("current_mapped_data", []);
    updateSourceInputs("current_mapped_data_main", []);
    updateSourceInputs("modified_mapped_data", []);
    updateSourceInputs("current_filters", []);
    updateSourceInputs("appliedFilters", []);
    updateSourceInputs("download_sample_file", []);
    updateSourceInputs("filtered_Rows", []);
    updateSourceInputs("current_columns", []);
    updateSourceInputs("actualData", []);
    updateSourceInputs("recommendedModel", []);
    updateSourceInputs("approvalData", []);
    updateSourceInputs("approvalTable_Header", []);
  };

  useEffect(() => {
    if (
      source_data.current_category != "" &&
      source_data.current_source != ""
    ) {
      setPage(0);
    }
  }, [source_data.current_source, source_data.current_category]);

  useEffect(async () => {
    await getSources();
  }, []);

  const outlinedCNCButton = {
    borderColor: "#46596A",
    // background-color: #d7dadd,
    color: "#46596A",
    // width: '100%',
    fontFamily: "Hind Siliguri",
    fontSize: "12px",
    fontWeight: "bold",
    marginRight: "5px",
  };

  const containedButton = {
    color: "white",
    backgroundColor: "#46596A",
    fontFamily: "Hind Siliguri",
    fontSize: "12px",
    fontWeight: "bold",
    // marginLeft: "10px !important",
    marginRight: "5px",
  };

  //function to set page for changing table row
  const pageChange = (event, value) => {
    setPage(value);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  let page_props = {
    total: source_data.current_mapped_data
      ? Math.ceil(source_data.current_mapped_data.length / rowsPerPage)
      : 0,
    page: page,
    changePage: pageChange,
    rowsPerPage: rowsPerPage,
    handleChangeRowsPerPage: handleChangeRowsPerPage,
    show_pageOptions: true,
  };

  function cancelFunction() {
    setIsCancelDialogOpen(false);
    updateSourceInputs("checked_rows_count", 0);
    updateSourceInputs("current_source", "");
    updateSourceInputs("current_country", "");
    updateSourceInputs("current_country_code", "");
    updateSourceInputs("current_category", "");
    updateSourceInputs("current_filter_value", "");
    updateSourceInputs("current_table_name", "");
    updateSourceInputs("current_dimension", "");
    updateSourceInputs("dimensions_list", []);
    updateSourceInputs("current_mapped_source", []);
    updateSourceInputs("current_mapped_country", []);
    updateSourceInputs("current_category_data", []);
    updateSourceInputs("current_mapped_data", []);
    updateSourceInputs("modified_mapped_data", []);
    updateSourceInputs("appliedFilters", []);
    updateSourceInputs("searchValue", "");
    updateSourceInputs("filtered_Rows", []);
    updateSourceInputs("is_initial", true);
    updateSourceInputs("is_table_loading", true);
    updateSourceInputs("current_columns", []);
    updateSourceInputs("actualData", []);
    updateSourceInputs("recommendedModel", []);
    getSources();
  }

  const onSave = async () => {
    setIsTableDataSaving(true);
    // const PRIMARY_COLUMN = source_data?.data?.dropdown?.table_primary_key || "";
    const IS_SPREADABLE_DATA =
      source_data.data.dropdown.conversion_column_details.is_spread;
    const Convertion_Column_Details =
      source_data.data.dropdown.conversion_column_details.conversion_columns;
    const COUNTRY = source_data.current_mapped_country.find((item) => {
      return item.label === source_data.current_country;
    });

    const MODIFIED_MAPPED_DATA = source_data.modified_mapped_data.map(
      (item) => {
        const { IS_AI_RECOMMENDED, ...rest } = item || {};
        return {
          ...rest,
          UPDATED_BY: user.mail || "",
          COUNTRY: COUNTRY?.value || "",
          SOURCE_FILE_ID: source_data?.current_category || "",
        };
      },
    );

    let FINAL_MODIFIED_MAPPED_DATA = [];

    if (IS_SPREADABLE_DATA) {
      FINAL_MODIFIED_MAPPED_DATA = MODIFIED_MAPPED_DATA.map((item) => {
        let Spreadable_Columns = [];
        let All_Grouped_Spreaded_columns = {};
        let Spreadable_Column_Removed = {};

        // GET THE MATCHING SPREADABLE COLUMN DETAILS
        Object.keys(item).forEach((col_name) => {
          const matched = Convertion_Column_Details.filter((con_column) =>
            con_column.child_columns_name?.some(
              (child_col) => child_col === col_name,
            ),
          );

          // accumulate all matches
          if (matched.length > 0) {
            Spreadable_Columns.push(...matched);
          }
        });

        // GROUP THE SPREDABLE COLUMNS TO ITS PARENT COLUMN
        if (Spreadable_Columns.length > 0) {
          Spreadable_Columns.forEach((spread_col) => {
            Object.keys(item).forEach((key) => {
              if (spread_col.child_columns_name.includes(key)) {
                All_Grouped_Spreaded_columns = {
                  ...All_Grouped_Spreaded_columns,
                  [spread_col.parent_column_name]: {
                    ...All_Grouped_Spreaded_columns?.[
                      spread_col.parent_column_name
                    ],
                    [key]: item?.[key],
                  },
                };
              }
            });
          });
        } else {
          All_Grouped_Spreaded_columns = {};
        }

        // REMOVE'S THE SPREADED COLUMN FROM THE ROW DATA
        Object.keys(item).forEach((col_name) => {
          const isSpreadableColumn = Spreadable_Columns.some((spread_col) =>
            spread_col.child_columns_name.includes(col_name),
          );

          if (!isSpreadableColumn) {
            Spreadable_Column_Removed = {
              ...Spreadable_Column_Removed,
              [col_name]: item?.[col_name],
            };
          }
        });

        const FINAL = {
          ...Spreadable_Column_Removed,
          ...All_Grouped_Spreaded_columns,
        };
        return FINAL;
      });
    } else {
      FINAL_MODIFIED_MAPPED_DATA = MODIFIED_MAPPED_DATA;
    }

    try {
      const params = new URLSearchParams({
        country: source_data?.current_country_code || "",
        file_id: source_data?.current_category || "",
        dataset_name: source_data?.current_dimension?.value || "",
      });

      const response = await fetch(
        api + `/attribute_enrichment/updatetabledata?${params}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${user.token || ""}`,
          },
          body: JSON.stringify(FINAL_MODIFIED_MAPPED_DATA),
          credentials: "include",
        },
      );

      const data = await response.json();

      // Check if response is OK before trying to parse it
      if (!response.ok) {
        const data = await response.json().catch(() => ({}));
        if (data?.statusCode === "harbor-401") {
          updateAlert({
            open: true,
            message: `User Unauthorized. Please sign in.`,
            severity: "warning",
            closeFlag: true,
          });
          login(); // or redirect to login
          return;
        } else {
          throw new Error(`Unexpected error occured. Please try again later`);
        }
      }

      updateAlert({
        open: true,
        message: "All the changes are saved successfully",
        severity: "success",
        closeFlag: true,
      });
      getSources();
      updateSourceInputs("is_initial", true);
      setGlobalEdit(false);
      clearReduxState();
    } catch (err) {
      setIsTableDataSaving(false);
      updateAlert({
        open: true,
        message: `Unexpected error occured. Please try again later`,
        severity: "Failed ",
        closeFlag: true,
      });
      return;
    } finally {
      setIsTableDataSaving(false);
      setIsSaveDialogOpen(false);
    }
  };

  const addAwaitingData = async () => {
    setIsTableDataSaving(true);
    // const PRIMARY_COLUMN = source_data?.data?.dropdown?.table_primary_key || "";
    const IS_SPREADABLE_DATA =
      source_data.data.dropdown.conversion_column_details.is_spread;
    const Convertion_Column_Details =
      source_data.data.dropdown.conversion_column_details.conversion_columns;

    const MODIFIED_MAPPED_DATA = source_data.modified_mapped_data.map(
      (item) => {
        const { IS_AI_RECOMMENDED, ...rest } = item || {};
        return {
          ...rest,
          UPDATED_BY: user.mail || "",
          USERID: user.mail || "",
        };
      },
    );

    let FINAL_MODIFIED_MAPPED_DATA = [];

    if (IS_SPREADABLE_DATA) {
      const FULL_RECORD = source_data.current_mapped_data.filter((item) => {
        return MODIFIED_MAPPED_DATA.some(
          (mod_item) => mod_item.MARKET_TAG === item.rowData.MARKET_TAG,
        );
      });

      const SPREAD_COLUMN_SORTED = MODIFIED_MAPPED_DATA.map((item) => {
        let Spreadable_Columns = [];
        let All_Grouped_Spreaded_columns = {};
        let Spreadable_Column_Removed = {};

        // GET THE MATCHING SPREADABLE COLUMN DETAILS
        Object.keys(item).forEach((col_name) => {
          const matched = Convertion_Column_Details.filter((con_column) =>
            con_column.child_columns_name?.some(
              (child_col) => child_col === col_name,
            ),
          );

          // accumulate all matches
          if (matched.length > 0) {
            Spreadable_Columns.push(...matched);
          }
        });

        // GROUP THE SPREDABLE COLUMNS TO ITS PARENT COLUMN
        if (Spreadable_Columns.length > 0) {
          Spreadable_Columns.forEach((spread_col) => {
            Object.keys(item).forEach((key) => {
              if (spread_col.child_columns_name.includes(key)) {
                All_Grouped_Spreaded_columns = {
                  ...All_Grouped_Spreaded_columns,
                  [spread_col.parent_column_name]: {
                    ...All_Grouped_Spreaded_columns?.[
                      spread_col.parent_column_name
                    ],
                    [key]: item?.[key],
                  },
                };
              }
            });
          });
        } else {
          All_Grouped_Spreaded_columns = {};
        }

        // REMOVE'S THE SPREADED COLUMN FROM THE ROW DATA
        Object.keys(item).forEach((col_name) => {
          const isSpreadableColumn = Spreadable_Columns.some((spread_col) =>
            spread_col.child_columns_name.includes(col_name),
          );

          if (!isSpreadableColumn) {
            Spreadable_Column_Removed = {
              ...Spreadable_Column_Removed,
              [col_name]: item?.[col_name],
            };
          }
        });

        const FINAL = {
          ...Spreadable_Column_Removed,
          ...All_Grouped_Spreaded_columns,
        };
        return FINAL;
      });

      FINAL_MODIFIED_MAPPED_DATA = FULL_RECORD.map((item) => {
        const MATCHING_MODIFIED_RECORDS = SPREAD_COLUMN_SORTED.find(
          (spread_item) => spread_item.MARKET_TAG === item.rowData.MARKET_TAG,
        );
        const FINAL = {
          ...item.rowData,
          ...MATCHING_MODIFIED_RECORDS,
        };
        return FINAL;
      });
    } else {
      const FULL_RECORD = source_data.current_mapped_data.filter((item) => {
        return MODIFIED_MAPPED_DATA.some(
          (mod_item) =>
            mod_item?.[source_data?.data?.dropdown?.table_primary_key || ""] ===
            item.rowData?.[
              source_data?.data?.dropdown?.table_primary_key || ""
            ],
        );
      });

      FINAL_MODIFIED_MAPPED_DATA = FULL_RECORD.map((item) => {
        const MATCHING_MODIFIED_RECORDS = MODIFIED_MAPPED_DATA.find(
          (spread_item) =>
            spread_item?.[
              source_data?.data?.dropdown?.table_primary_key || ""
            ] ===
            item.rowData?.[
              source_data?.data?.dropdown?.table_primary_key || ""
            ],
        );
        const FINAL = {
          ...item.rowData,
          ...(MATCHING_MODIFIED_RECORDS || {}),
        };
        const { IS_AI_RECOMMENDED, ...rest } = FINAL || {};
        return rest;
      });
    }

    try {
      const params = new URLSearchParams({
        country: source_data?.current_country_code || "",
        category: source_data?.current_category || "",
        dataset_name: source_data?.current_dimension?.value || "",
        usecase: "attribute_enrichment",
        userid: user.mail || "",
      });

      const response = await fetch(
        api + `/attribute_enrichment/add_awaiting_data?${params}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${user.token || ""}`,
          },
          body: JSON.stringify(FINAL_MODIFIED_MAPPED_DATA),
          credentials: "include",
        },
      );

      // Check if response is OK before trying to parse it
      if (!response.ok) {
        const data = await response.json().catch(() => ({}));
        if (data?.statusCode === "harbor-401") {
          updateAlert({
            open: true,
            message: `User Unauthorized. Please sign in.`,
            severity: "warning",
            closeFlag: true,
          });
          login(); // or redirect to login
          return;
        } else {
          throw new Error(`Unexpected error occured. Please try again later`);
        }
      }

      updateAlert({
        open: true,
        message:
          "All the changes are saved successfully & awaiting for approval",
        severity: "success",
        closeFlag: true,
      });
      getSources();
      updateSourceInputs("is_initial", true);
      setGlobalEdit(false);
      clearReduxState();
    } catch (err) {
      setIsTableDataSaving(false);
      updateAlert({
        open: true,
        message: `Unexpected error occured. Please try again later`,
        severity: "Failed ",
        closeFlag: true,
      });
      return;
    } finally {
      setIsTableDataSaving(false);
      setIsSaveDialogOpen(false);
    }
  };

  const updateAwaitingData = async () => {
    setIsTableDataSaving(true);
    // const PRIMARY_COLUMN = source_data?.data?.dropdown?.table_primary_key || "";
    const IS_SPREADABLE_DATA =
      source_data.data.dropdown.conversion_column_details.is_spread;
    const Convertion_Column_Details =
      source_data.data.dropdown.conversion_column_details.conversion_columns;

    const MODIFIED_MAPPED_DATA = source_data.modified_mapped_data.map(
      (item) => {
        const { IS_AI_RECOMMENDED, ...rest } = item || {};
        return {
          ...rest,
          UPDATED_BY: user.mail || "",
          USERID: user.mail || "",
        };
      },
    );

    let FINAL_MODIFIED_MAPPED_DATA = [];

    if (IS_SPREADABLE_DATA) {
      const FULL_RECORD = source_data.current_mapped_data.filter((item) => {
        return MODIFIED_MAPPED_DATA.some(
          (mod_item) => mod_item.MARKET_TAG === item.rowData.MARKET_TAG,
        );
      });

      const SPREAD_COLUMN_SORTED = MODIFIED_MAPPED_DATA.map((item) => {
        let Spreadable_Columns = [];
        let All_Grouped_Spreaded_columns = {};
        let Spreadable_Column_Removed = {};

        // GET THE MATCHING SPREADABLE COLUMN DETAILS
        Object.keys(item).forEach((col_name) => {
          const matched = Convertion_Column_Details.filter((con_column) =>
            con_column.child_columns_name?.some(
              (child_col) => child_col === col_name,
            ),
          );

          // accumulate all matches
          if (matched.length > 0) {
            Spreadable_Columns.push(...matched);
          }
        });

        // GROUP THE SPREDABLE COLUMNS TO ITS PARENT COLUMN
        if (Spreadable_Columns.length > 0) {
          Spreadable_Columns.forEach((spread_col) => {
            Object.keys(item).forEach((key) => {
              if (spread_col.child_columns_name.includes(key)) {
                All_Grouped_Spreaded_columns = {
                  ...All_Grouped_Spreaded_columns,
                  [spread_col.parent_column_name]: {
                    ...All_Grouped_Spreaded_columns?.[
                      spread_col.parent_column_name
                    ],
                    [key]: item?.[key],
                  },
                };
              }
            });
          });
        } else {
          All_Grouped_Spreaded_columns = {};
        }

        // REMOVE'S THE SPREADED COLUMN FROM THE ROW DATA
        Object.keys(item).forEach((col_name) => {
          const isSpreadableColumn = Spreadable_Columns.some((spread_col) =>
            spread_col.child_columns_name.includes(col_name),
          );

          if (!isSpreadableColumn) {
            Spreadable_Column_Removed = {
              ...Spreadable_Column_Removed,
              [col_name]: item?.[col_name],
            };
          }
        });

        const FINAL = {
          ...Spreadable_Column_Removed,
          ...All_Grouped_Spreaded_columns,
        };
        return FINAL;
      });

      FINAL_MODIFIED_MAPPED_DATA = FULL_RECORD.map((item) => {
        const MATCHING_MODIFIED_RECORDS = SPREAD_COLUMN_SORTED.find(
          (spread_item) => spread_item.MARKET_TAG === item.rowData.MARKET_TAG,
        );
        const FINAL = {
          ...item.rowData,
          ...MATCHING_MODIFIED_RECORDS,
        };
        return FINAL;
      });
    } else {
      const FULL_RECORD = source_data.current_mapped_data.filter((item) => {
        return MODIFIED_MAPPED_DATA.some(
          (mod_item) =>
            mod_item?.[source_data?.data?.dropdown?.table_primary_key || ""] ===
            item.rowData?.[
              source_data?.data?.dropdown?.table_primary_key || ""
            ],
        );
      });

      FINAL_MODIFIED_MAPPED_DATA = FULL_RECORD.map((item) => {
        const MATCHING_MODIFIED_RECORDS = MODIFIED_MAPPED_DATA.find(
          (spread_item) =>
            spread_item?.[
              source_data?.data?.dropdown?.table_primary_key || ""
            ] ===
            item.rowData?.[
              source_data?.data?.dropdown?.table_primary_key || ""
            ],
        );
        const FINAL = {
          ...item.rowData,
          ...(MATCHING_MODIFIED_RECORDS || {}),
        };
        const { IS_AI_RECOMMENDED, ...rest } = FINAL || {};
        return rest;
      });
    }

    try {
      const params = new URLSearchParams({
        country: source_data?.current_country_code || "",
        category: source_data?.current_category || "",
        dataset_name: source_data?.current_dimension?.value || "",
        usecase: "attribute_enrichment",
        userid: user.mail || "",
      });

      const response = await fetch(
        api + `/attribute_enrichment/update_awaiting_data?${params}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${user.token || ""}`,
          },
          body: JSON.stringify(FINAL_MODIFIED_MAPPED_DATA),
          credentials: "include",
        },
      );

      // Check if response is OK before trying to parse it
      if (!response.ok) {
        const data = await response.json().catch(() => ({}));
        if (data?.statusCode === "harbor-401") {
          updateAlert({
            open: true,
            message: `User Unauthorized. Please sign in.`,
            severity: "warning",
            closeFlag: true,
          });
          login(); // or redirect to login
          return;
        } else {
          throw new Error(`Unexpected error occured. Please try again later`);
        }
      }

      updateAlert({
        open: true,
        message:
          "All the changes are saved successfully & awaiting for approval",
        severity: "success",
        closeFlag: true,
      });
      getSources();
      updateSourceInputs("is_initial", true);
      setGlobalEdit(false);
      clearReduxState();
    } catch (err) {
      setIsTableDataSaving(false);
      updateAlert({
        open: true,
        message: `Unexpected error occured. Please try again later`,
        severity: "Failed ",
        closeFlag: true,
      });
      return;
    } finally {
      setIsTableDataSaving(false);
      setIsSaveDialogOpen(false);
    }
  };

  const setMappedData = async (dataset, country, cmu, filter) => {
    setIsPlaceholderFetching(true);
    setGlobalEdit(false);
    updateSourceInputs("is_initial", true);
    updateSourceInputs("is_table_loading", true);

    let filteredDatasetValue;
    let DownloadSampleData;
    let have_awaiting_records = {};

    const Meta_Filters = source_data.data.dropdown.metadata_filter;
    try {
      const COUNTRY = source_data.current_mapped_country.find((item) => {
        return item.label === country;
      });

      const params = new URLSearchParams({
        country: COUNTRY?.value || "",
        category: cmu || "",
        dataset_name: dataset || "",
        filter: filter || "",
        dropdown_filter: "dropdown",
        usecase: "attribute_enrichment",
        userid: user.mail || "",
      });

      const response = await fetch(
        api + `/attribute_enrichment/fetchtabledata?${params}`,
        {
          method: "GET",
          mode: "cors",
          credentials: "include",
          headers: {
            Authorization: `Bearer ${user.token || ""}`,
            "Content-Type": "application/json",
          },
        },
      );

      const data = await response.json();

      // Check if response is OK before trying to parse it
      if (!response.ok) {
        const data = await response.json().catch(() => ({}));
        if (data?.statusCode === "harbor-401") {
          updateAlert({
            open: true,
            message: `User Unauthorized. Please sign in.`,
            severity: "warning",
            closeFlag: true,
          });
          login(); // or redirect to login
          setIsPlaceholderFetching(false);
          return;
        } else {
          throw new Error(`Unexpected error occured. Please try again later`);
        }
      }

      if (!data || !data.data) {
        throw new Error("Unexpected error occured. Please try again later");
      }

      if (source_data.data.dropdown.is_value_fetch) {
        const VALUES = data.values_data;
        const VALUES_WITHOUT_NULL =
          Array.isArray(VALUES) && VALUES.length > 0
            ? VALUES.filter(
                (item) =>
                  item !== null &&
                  item !== "null" &&
                  item !== "" &&
                  item !== undefined,
              )
            : [];
        const UPDATED_DROPDOWN_DATA = {
          ...source_data.data,
          dropdown: {
            ...source_data.data.dropdown,
            VALUE: VALUES_WITHOUT_NULL,
          },
        };

        updateSourceInputs("data", UPDATED_DROPDOWN_DATA);
      }

      if (data && data?.data) {
        const DATA = data.data[0];
        have_awaiting_records = {
          has_records: data.awaiting_data_present || false,
          has_access: data.statusCode === "harbor-201" ? true : false,
          editor: DATA?.username || "",
          approver: DATA?.approver || "",
        };
        updateSourceInputs("has_awaiting_data", have_awaiting_records);

        filteredDatasetValue = data.data;
      }

      if (data && data.dropdown) {
        const DROPDOWN_DATAS = data?.dropdown || {};
        const FINAL_DATA = {
          ...source_data.data,
          dropdown: {
            ...source_data.data.dropdown,
            ...DROPDOWN_DATAS,
          },
        };
        updateSourceInputs("data", FINAL_DATA);
      }

      DownloadSampleData = data?.sample_data || [];
    } catch (err) {
      updateAlert({
        open: true,
        message: `Unexpected error occured. Please try again later`,
        severity: "error ",
        closeFlag: true,
      });
      setIsPlaceholderFetching(false);
      updateSourceInputs("has_awaiting_data", false);
      return;
    }

    let val = filteredDatasetValue || [];
    let ITEM_ID = 0;
    let tableData =
      val &&
      val.map((item) => {
        const rowData = {
          item_Id: ITEM_ID,
          isEditing: false,
          isCheckedRow: false,
          uniqueKey: item["Item_code"],
          rowData: item,
        };
        ITEM_ID++;
        return rowData;
      });

    const Convertion_Column_Details =
      source_data.data.dropdown.conversion_column_details.conversion_columns;

    const Spreaded_Column_Data = tableData.map((item) => {
      let All_Spreaded_columns = {};
      let Spreadable_Column_Removed = {};

      // SPREADS THE SPREDABLE COLUMNS
      Object.keys(item.rowData).forEach((col_name) => {
        let Spreadable_Columns = Convertion_Column_Details.filter(
          (con_column) => con_column.parent_column_name === col_name,
        );
        if (Spreadable_Columns.length > 0) {
          Spreadable_Columns.forEach((spread_col) => {
            All_Spreaded_columns = {
              ...All_Spreaded_columns,
              ...item.rowData?.[spread_col.parent_column_name],
            };
          });
        }
      });

      // REMOVE'S THE SPREADABLE COLUMN FROM THE ROW DATA
      Object.keys(item.rowData).forEach((col_name) => {
        const isSpreadableColumn = Convertion_Column_Details.some(
          (spread_col) => spread_col.parent_column_name === col_name,
        );

        if (!isSpreadableColumn) {
          Spreadable_Column_Removed = {
            ...Spreadable_Column_Removed,
            [col_name]: item.rowData?.[col_name],
          };
        }
      });

      const FINAL_ROWDATA = {
        ...Spreadable_Column_Removed,
        ...All_Spreaded_columns,
      };

      return { ...item, rowData: FINAL_ROWDATA };
    });

    const FINAL_CURRENT_MAPPED_DATA = source_data?.data?.dropdown
      ?.conversion_column_details?.is_spread
      ? Spreaded_Column_Data
      : (tableData?.map((item) => {
          return {
            ...item,
            rowData: { ...item.rowData, IS_AI_RECOMMENDED: false },
          };
        }) ?? []);

    // SAMPLE FILE DOWNLOAD DATA
    const SAMPLE_DOWNLOAD_FILE =
      DownloadSampleData?.map((item) => {
        let rowData = item;
        Object.keys(rowData).forEach((key) => {
          if (
            rowData[key] === "null" ||
            rowData[key] === undefined ||
            rowData[key] === null
          ) {
            rowData[key] = null;
          }
        });
        const Altered_RowData = rowData;

        rowData = {
          ...Altered_RowData,
          [Meta_Filters?.[0]]: source_data.current_country,
          [Meta_Filters?.[1]]: cmu,
        };
        return rowData;
      }) ?? [];

    // TABLE_DROPDOWN_DATA
    updateSourceInputs("current_mapped_data", FINAL_CURRENT_MAPPED_DATA);
    updateSourceInputs("current_mapped_data_main", FINAL_CURRENT_MAPPED_DATA);
    updateSourceInputs("download_sample_file", SAMPLE_DOWNLOAD_FILE);

    if (have_awaiting_records && have_awaiting_records.has_records) {
      setIsDynamicDialogOpen(true);
      setDynamicDialogMessage(
        have_awaiting_records.has_access
          ? "Your awaiting data available for this file_Id, Do you want to fetch ?"
          : `Awaiting data available for this SFF_File_Id. ${
              `${have_awaiting_records?.editor} ${
                have_awaiting_records?.editor.length > 1 ? "are" : "is"
              } ` || ""
            } the ${
              have_awaiting_records?.editor.length > 1 ? "editors" : "editor"
            } and ${
              `${have_awaiting_records?.approver} ${
                have_awaiting_records?.approver.length > 1 ? "are" : "is"
              } ` || ""
            } the ${
              have_awaiting_records?.approver.length > 1
                ? "approvers"
                : "approver"
            }. Kindly contact them for further assistance`,
      );
    } else {
      setIsPlaceholderFetching(false);
    }
  };

  const fetchAwaitingRecords = async () => {
    setIsDynamicDialogOpen(false);

    let filteredDatasetValue;
    try {
      const COUNTRY = source_data.current_mapped_country.find((item) => {
        return item.label === source_data.current_country;
      });

      const params = new URLSearchParams({
        country: COUNTRY?.value || "",
        category: source_data.current_category || "",
        dataset_name: source_data?.current_dimension?.value || "",
        usecase: "attribute_enrichment",
        userid: user.mail || "",
      });

      const response = await fetch(
        api + `/attribute_enrichment/get_awaiting_table_data?${params}`,
        {
          method: "GET",
          mode: "cors",
          credentials: "include",
          headers: {
            Authorization: `Bearer ${user.token || ""}`,
            "Content-Type": "application/json",
          },
        },
      );

      const data = await response.json();

      // Check if response is OK before trying to parse it
      if (!response.ok) {
        const data = await response.json().catch(() => ({}));
        if (data?.statusCode === "harbor-401") {
          updateAlert({
            open: true,
            message: `User Unauthorized. Please sign in.`,
            severity: "warning",
            closeFlag: true,
          });
          login(); // or redirect to login
          setIsPlaceholderFetching(false);
          return;
        } else {
          throw new Error(`Unexpected error occured. Please try again later`);
        }
      }

      if (!data || !data.data) {
        throw new Error("Unexpected error occured. Please try again later");
      }

      if (data && data?.data) {
        filteredDatasetValue = data.data;
      }
    } catch (err) {
      updateAlert({
        open: true,
        message: `Unexpected error occured. Please try again later`,
        severity: "error ",
        closeFlag: true,
      });
      setIsPlaceholderFetching(false);
      updateSourceInputs("has_awaiting_data", false);
      return;
    }

    let val = filteredDatasetValue || [];
    let ITEM_ID = 0;
    let tableData =
      val &&
      val.map((item) => {
        const rowData = {
          item_Id: ITEM_ID,
          isEditing: false,
          isCheckedRow: false,
          uniqueKey: item["Item_code"],
          rowData: item,
        };
        ITEM_ID++;
        return rowData;
      });

    const Convertion_Column_Details =
      source_data.data.dropdown.conversion_column_details.conversion_columns;

    const Spreaded_Column_Data = tableData.map((item) => {
      let All_Spreaded_columns = {};
      let Spreadable_Column_Removed = {};

      // SPREADS THE SPREDABLE COLUMNS
      Object.keys(item.rowData).forEach((col_name) => {
        let Spreadable_Columns = Convertion_Column_Details.filter(
          (con_column) => con_column.parent_column_name === col_name,
        );
        if (Spreadable_Columns.length > 0) {
          Spreadable_Columns.forEach((spread_col) => {
            All_Spreaded_columns = {
              ...All_Spreaded_columns,
              ...item.rowData?.[spread_col.parent_column_name],
            };
          });
        }
      });

      // REMOVE'S THE SPREADABLE COLUMN FROM THE ROW DATA
      Object.keys(item.rowData).forEach((col_name) => {
        const isSpreadableColumn = Convertion_Column_Details.some(
          (spread_col) => spread_col.parent_column_name === col_name,
        );

        if (!isSpreadableColumn) {
          Spreadable_Column_Removed = {
            ...Spreadable_Column_Removed,
            [col_name]: item.rowData?.[col_name],
          };
        }
      });

      const FINAL_ROWDATA = {
        ...Spreadable_Column_Removed,
        ...All_Spreaded_columns,
      };

      return { ...item, rowData: FINAL_ROWDATA };
    });

    const FINAL_CURRENT_MAPPED_DATA = source_data?.data?.dropdown
      ?.conversion_column_details?.is_spread
      ? Spreaded_Column_Data
      : (tableData?.map((item) => {
          return {
            ...item,
            rowData: { ...item.rowData, IS_AI_RECOMMENDED: false },
          };
        }) ?? []);

    // TABLE_DROPDOWN_DATA
    updateSourceInputs("current_mapped_data", FINAL_CURRENT_MAPPED_DATA);
    updateSourceInputs("current_mapped_data_main", FINAL_CURRENT_MAPPED_DATA);
    setIsPlaceholderFetching(false);
  };

  const handleSourceInput = (data, selectedRowsCount) => {
    updateSourceInputs("current_mapped_data", data);
    updateSourceInputs("checked_rows_count", selectedRowsCount);
  };

  const [isModelMode, SetIsModelMode] = useState(false);
  const [isOpenModel, SetIsOpenModel] = useState(false);
  const [isRecommanded, SetIsRecommanded] = useState(false);

  const getResponseWithJobId = async (url) => {
    try {
      const response = await fetch(url, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${props.user.token || ""}`,
          "Content-Type": "application/json",
        },
      });

      // Check if response is OK before trying to parse it
      if (!response.ok) {
        if (response.status === 401) {
          updateAlert({
            open: true,
            message: `User Unauthorized. Please sign in.`,
            severity: "warning",
            closeFlag: true,
          });
          login(); // or redirect to login
          return;
        } else {
          updateSourceInputs("get_recommendation_status", "Failed");
          updateSourceInputs("get_recommendation_error_message", {
            status: true,
            message: "Unexpected error occured. Please try again later",
          });
          throw new Error("Unexpected error occured. Please try again later");
        }
      }
      return await response.json();
    } catch (err) {
      updateAlert({
        open: true,
        message: "Unexpected error occured. Please try again later",
        severity: "error",
        closeFlag: true,
      });
      updateSourceInputs("get_recommendation_status", "Failed");
      updateSourceInputs("get_recommendation_error_message", {
        status: true,
        message: "Unexpected error occured. Please try again later",
      });
      return null;
    }
  };

  const validateResponse = async (response, jobId) => {
    if (!response) {
      updateAlert({
        open: true,
        message: `Response not found. Please try again later or contact support if the issue persists.`,
        severity: "warning",
        closeFlag: true,
      });
      updateSourceInputs("get_recommendation_status", "Failed");
      updateSourceInputs("get_recommendation_error_message", {
        status: true,
        message:
          "Response not found. Please try again later or contact support if the issue persists.",
      });
      return;
    }

    if (response?.status?.failed && response?.status?.failed.length > 0) {
      setLoading(false);
      updateAlert({
        open: true,
        message: `Process failed. Please try again or contact support if the issue persists.`,
        severity: "warning",
        closeFlag: true,
      });
      updateSourceInputs("get_recommendation_status", "Failed");
      updateSourceInputs("get_recommendation_error_message", {
        status: true,
        message:
          "Process failed. Please try again or contact support if the issue persists.",
      });
      return;
    }

    // queued or running → poll again after 2s
    if (
      response?.status?.queued?.length > 0 ||
      response?.status?.running?.length > 0
    ) {
      const url = `${
        source_data?.data?.dropdown?.recommendation_details?.recommendation_url
      }/predictions/jobById?id=${jobId || ""}`;

      setTimeout(async () => {
        const nextResponse = await getResponseWithJobId(url);
        validateResponse(nextResponse, jobId);
      }, 10000);

      return;
    }

    // success → transform response
    const ALL_MODEL_DATA = Object.keys(response.data || {}).reduce(
      (acc, modelKey) => {
        let Random_ID = 0;
        const updatedItems = response.data[modelKey].map((item) => ({
          ...item,
          model_name: modelKey,
          item_ID: Random_ID++,
          isEditing: false,
        }));
        acc[modelKey] = updatedItems;
        return acc;
      },
      {},
    );

    // Sort Data based on best Score
    updateSourceInputs("get_recommendation_all_modal_data", ALL_MODEL_DATA);

    // TRIGGER ACKNOWLEDGE API
    try {
      const predictUrl = `${source_data?.data?.dropdown?.recommendation_details?.recommendation_url}/predictions/acknowledge`;
      const body = { jobIds: [jobId] };
      const response = await fetch(predictUrl, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${props.user.token || ""}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(body),
      });

      // Check if response is OK before trying to parse it
      if (!response.ok) {
        if (response.status === 401) {
          updateAlert({
            open: true,
            message: `User Unauthorized. Please sign in.`,
            severity: "warning",
            closeFlag: true,
          });
          login(); // or redirect to login
          return;
        } else {
          updateSourceInputs("get_recommendation_status", "Failed");
          updateSourceInputs("get_recommendation_error_message", {
            status: true,
            message: "Unexpected error occured. Please try again later",
          });
          throw new Error("Unexpected error occured. Please try again later");
        }
      }
    } catch (err) {
      updateAlert({
        open: true,
        message: "Unexpected error occured. Please try again later",
        severity: "error",
        closeFlag: true,
      });
      updateSourceInputs("get_recommendation_status", "Failed");
      updateSourceInputs("get_recommendation_error_message", {
        status: true,
        message: "Unexpected error occured. Please try again later",
      });
      return null;
    } finally {
      updateSourceInputs("get_recommendation_status", "Success");
    }
  };

  const getAIRecommandation = async (Actual_Data) => {
    const SKU_DESCRIPTION_NAME =
      source_data?.data?.dropdown?.recommendation_details
        ?.sku_description_column_name || "";
    updateSourceInputs("get_recommendation_status", "In Progress");

    const MODEL_NAME = source_data.current_category;
    const DATASET_NAME = source_data?.current_source?.toLowerCase() || "";
    const parts = MODEL_NAME.split("_"); // ["RB", "GI", "COMBINED", "AU"]
    const COUNTRY_CODE = parts[parts.length - 1].toLowerCase(); // au
    const CMU = parts.slice(1, -1).join("").toLowerCase(); // gicombined

    const TARGET_MODEL_NAME = `sku_description_${DATASET_NAME}_${COUNTRY_CODE}_${CMU}_doses_calculation`;
    const TARGET_VALUE_LABEL = SKU_DESCRIPTION_NAME;

    const predictUrl = `${
      source_data?.data?.dropdown?.recommendation_details?.recommendation_url
    }/predictions/predict?userId=${user?.mail || ""}&username=${
      user?.displayName
    }&input=sku_description`;

    const requestBody = Actual_Data.map((item) => ({
      [TARGET_MODEL_NAME]: item.rowData[TARGET_VALUE_LABEL] || "",
    }));

    try {
      const response = await fetch(predictUrl, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${props.user.token || ""}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestBody),
      });

      // Check if response is OK before trying to parse it
      if (!response.ok) {
        if (response?.status === 401) {
          updateAlert({
            open: true,
            message: `User Unauthorized. Please sign in.`,
            severity: "warning",
            closeFlag: true,
          });
          setLoading(false);
          login();
          return;
        } else {
          updateSourceInputs("get_recommendation_error_message", {
            status: true,
            message: "Unexpected error occured. Please try again later",
          });
          throw new Error("Unexpected error occured. Please try again later");
        }
      }

      const data = await response.json();
      validateResponse(data, data.jobId);
    } catch (err) {
      updateAlert({
        open: true,
        message: "Unexpected error occured. Please try again later",
        severity: "error",
        closeFlag: true,
      });
      updateSourceInputs("get_recommendation_status", "Failed");
      updateSourceInputs("get_recommendation_error_message", {
        status: true,
        message: `${"Unexpected error occured. Please try again later"}`,
      });
    }
  };

  const validateMetaSelectionColumns = (tdata) => {
    let hasValidValuesForMetaColumns = { status: false, errorMessage: "" };
    tdata?.forEach((item) => {
      if (
        !item["COUNTRY"] ||
        item["COUNTRY"] === "" ||
        item["COUNTRY"] === null ||
        item["COUNTRY"] === undefined
      ) {
        hasValidValuesForMetaColumns = {
          status: true,
          errorMessage: "Invalid country value found in the uploaded file.",
        };
        return;
      }
      if (
        !item["SOURCE_FILE_ID"] ||
        item["SOURCE_FILE_ID"] === "" ||
        item["SOURCE_FILE_ID"] === null ||
        item["SOURCE_FILE_ID"] === undefined
      ) {
        hasValidValuesForMetaColumns = {
          status: true,
          errorMessage: "Invalid SFF File ID value found in the uploaded file.",
        };
        return;
      }

      if (item["COUNTRY"] !== source_data?.current_country) {
        hasValidValuesForMetaColumns = {
          status: true,
          errorMessage: "Invalid country value found in the uploaded file.",
        };
        return;
      }
      if (item["SOURCE_FILE_ID"] !== source_data?.current_category) {
        hasValidValuesForMetaColumns = {
          status: true,
          errorMessage: "Invalid SFF File ID value found in the uploaded file.",
        };
        return;
      }
      hasValidValuesForMetaColumns = { status: false, errorMessage: "" };
    });
    return hasValidValuesForMetaColumns;
  };

  const handleFileUpload = (records) => {
    // VALIDATION PART
    updateSourceInputs("isFileUploaded", true);
    updateSourceInputs("is_file_uploaded", true);

    const parseJsonValue = (value) => {
      if (value === null || value === undefined) return value;
      if (typeof value !== "string") return value;
      const trimmed = value.trim();
      if (!trimmed.startsWith("{") && !trimmed.startsWith("[")) return value;
      try {
        return JSON.parse(value);
      } catch (err) {
        return value;
      }
    };

    const normalizeRecord = (record) =>
      Object.entries(record || {}).reduce((acc, [key, value]) => {
        acc[key] = parseJsonValue(value);
        return acc;
      }, {});

    const Current_Table_Data = (records || []).map((item) => ({
      ...item,
      ...normalizeRecord(item),
    }));

    const validationResult = validateMetaSelectionColumns(Current_Table_Data);

    if (validationResult && validationResult.status) {
      updateSourceInputs("isFileUploaded", false);
      updateSourceInputs("is_file_uploaded", false);
      setIsFileUploading(false);
      updateAlert({
        open: true,
        message: `Validation Failed. ${
          validationResult?.errorMessage || "Please check the uploaded file."
        }`,
        severity: "warning",
        closeFlag: true,
      });
      return;
    }

    let ITEM_ID = 0;
    let tableData =
      Current_Table_Data &&
      Current_Table_Data.map((item) => {
        const rowData = {
          item_Id: ITEM_ID,
          isEditing: false,
          isCheckedRow: false,
          uniqueKey: item["Item_code"],
          rowData: item,
        };
        ITEM_ID++;
        return rowData;
      });

    const Convertion_Column_Details =
      source_data.data.dropdown.conversion_column_details.conversion_columns;

    const Spreaded_Column_Data =
      tableData?.map((item) => {
        let All_Spreaded_columns = {};
        let Spreadable_Column_Removed = {};

        // SPREADS THE SPREDABLE COLUMNS
        Object.keys(item.rowData).forEach((col_name) => {
          let Spreadable_Columns = Convertion_Column_Details.filter(
            (con_column) => con_column.parent_column_name === col_name,
          );
          if (Spreadable_Columns.length > 0) {
            Spreadable_Columns.forEach((spread_col) => {
              All_Spreaded_columns = {
                ...All_Spreaded_columns,
                ...item.rowData?.[spread_col.parent_column_name],
              };
            });
          }
        });

        // REMOVE'S THE SPREADABLE COLUMN FROM THE ROW DATA
        Object.keys(item.rowData).forEach((col_name) => {
          const isSpreadableColumn = Convertion_Column_Details.some(
            (spread_col) => spread_col.parent_column_name === col_name,
          );

          if (!isSpreadableColumn) {
            Spreadable_Column_Removed = {
              ...Spreadable_Column_Removed,
              [col_name]: item.rowData?.[col_name],
            };
          }
        });

        const FINAL_ROWDATA = {
          ...Spreadable_Column_Removed,
          ...All_Spreaded_columns,
        };

        return { ...item, rowData: FINAL_ROWDATA };
      }) ?? [];

    const FINAL_CURRENT_MAPPED_DATA = source_data?.data?.dropdown
      ?.conversion_column_details?.is_spread
      ? Spreaded_Column_Data
      : (tableData?.map((item) => {
          return {
            ...item,
            rowData: {
              ...item.rowData,
              IS_AI_RECOMMENDED: item?.IS_AI_RECOMMENDED
                ? item?.IS_AI_RECOMMENDED
                : false,
            },
          };
        }) ?? []);

    const MODIFIED_MAPPED_DATA =
      Current_Table_Data?.map((item) => {
        return {
          actual: {},
          isNew: false,
          isEdited: true,
          updated: { ...(item?.rowData || {}) },
        };
      }) ?? [];

    updateSourceInputs("modified_mapped_data", MODIFIED_MAPPED_DATA);
    updateSourceInputs("current_mapped_data", FINAL_CURRENT_MAPPED_DATA);
    updateSourceInputs("is_initial", false);
    updateSourceInputs("is_table_loading", false);
    setIsFileUploading(false);

    // RECOMMENDATION API PART
    const tableColumnList =
      source_data?.data?.dropdown?.recommendation_details
        ?.recommendation_modal_column_list?.initial_header_column_list ?? [];

    const Sorted_Actual_Data = FINAL_CURRENT_MAPPED_DATA.map((data) => {
      let Final_Data = {};
      tableColumnList.forEach((tabData) => {
        if (data.rowData[tabData.value] !== undefined) {
          Final_Data[tabData.name] = data.rowData[tabData.value];
        }
      });
      return { ...data, rowData: Final_Data };
    });
    updateSourceInputs("fulactualdata", Sorted_Actual_Data);
  };

  // DIALOGS OPEN AND CLOSE FUNCTIONS
  const handleModalopen = () => {
    if (source_data.get_recommendation_for_all_rows) {
      if (source_data.get_recommendation_status === "Success") {
        SetIsModelMode(true);
        SetIsOpenModel(true);
        SetIsRecommanded(true);
      } else {
        updateAlert({
          open: true,
          message: `The recommendations are ${
            source_data?.get_recommendation_status || "In Progress"
          }. ${
            source_data?.get_recommendation_status === "Failed"
              ? "Cannot process, Please try again later"
              : "Please wait until it's completed"
          }.`,
          severity: "warning",
          closeFlag: true,
        });
      }
    } else {
      SetIsModelMode(true);
      SetIsOpenModel(true);
      SetIsRecommanded(true);
    }
  };

  const handleCloseModel = () => {
    SetIsModelMode(true);
    SetIsOpenModel(false);
    SetIsRecommanded(false);
  };

  const handleDialogClose = () => {
    if (!isTableDataSaving) {
      setIsSaveDialogOpen(false);
    }
  };

  const handleDialogOpen = () => {
    setIsSaveDialogOpen(true);
  };

  const handleDynamicDialogClose = () => {
    setIsDynamicDialogOpen(false);
    updateSourceInputs("has_awaiting_data", false);
    updateSourceInputs("is_initial", true);
    updateSourceInputs("is_table_loading", true);
    setIsPlaceholderFetching(false);
  };

  const getApprovalData = async () => {
    clearReduxState();
    setLoading(true);
    try {
      const params = new URLSearchParams({
        usecase_name: "attribute_enrichment",
        user_name: user.mail || "",
      });
      const response = await fetch(
        api + `/approval/getapprovaldata?${params}`,
        {
          method: "GET",
          mode: "cors",
          credentials: "include",
          headers: {
            Authorization: `Bearer ${user.token || ""}`,
            "Content-Type": "application/json",
          },
        },
      );

      const data = await response.json();

      // Check if response is OK before trying to parse it
      if (!response.ok) {
        if (data?.statusCode === "harbor-401") {
          updateAlert({
            open: true,
            message: `User Unauthorized. Please sign in.`,
            severity: "warning",
            closeFlag: true,
          });
          login(); // or redirect to login
          return;
        } else {
          throw new Error(`Unexpected error occured. Please try again later`);
        }
      }

      if (!data || !data.data) {
        throw new Error("Unexpected error occured. Please try again later");
      }

      updateSourceInputs("approvalData", data.data);
      updateSourceInputs(
        "approvalTable_Header",
        data?.metadata?.table_headers || [],
      );
    } catch (err) {
      updateAlert({
        open: true,
        message: `Unexpected error occured. Please try again later`,
        severity: "success",
        closeFlag: true,
      });
    } finally {
      setLoading(false);
    }
  };

  const goBackFunction = () => {
    updateSourceInputs("is_initial", true);
    updateSourceInputs("is_table_loading", true);
    updateSourceInputs(
      "current_mapped_data",
      source_data?.current_mapped_data_main,
    );
    updateSourceInputs("get_recommendation_for_all_rows", false);
    updateSourceInputs("get_recommendation_status", "");
    updateSourceInputs("get_recommendation_error_message", {
      status: false,
      message: "",
    });
    updateSourceInputs("get_recommendation_all_modal_data", []);
    updateSourceInputs("fulactualdata", []);
    setGlobalEdit(false);
    setIsBackDialogOpen(false);
  };

  useEffect(() => {
    if (
      source_data.get_recommendation_for_all_rows &&
      Array.isArray(source_data.fulactualdata) &&
      source_data.fulactualdata.length > 0
    ) {
      getAIRecommandation(source_data.fulactualdata);
    }
  }, [source_data.get_recommendation_for_all_rows, source_data.fulactualdata]);

  return (
    <>
      <LayoutTopSideBottom match={match}>
        {/* Breadcrumbs and Approval Option */}
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: is_Approver ? "10px" : "0px",
          }}
        >
          <Breadcrumbs match={match} />
          {is_Approver && (
            <ApprovalButton
              buttonText={
                source_data?.data?.dropdown?.approver_details?.button_text ||
                "Approval"
              }
              getApprovalData={getApprovalData}
              isApproval={isApproval}
              setIsApproval={setIsApproval}
              getSources={getSources}
              isTableDataLoading={
                !source_data.is_initial && source_data.is_table_loading
              }
              any_row_isEditing={source_data?.any_row_isEditing}
              sourceData={source_data}
            />
          )}
        </div>

        {loading ? (
          <Loader />
        ) : isApproval ? (
          <ApprovalTable
            sourceData={source_data}
            user={user}
            login={login}
            updateAlert={updateAlert}
            getApprovalData={getApprovalData}
            usecase_name={"attribute_enrichment"}
          />
        ) : (
          <MetaSearchFilters
            loading={loading}
            setMappedData={setMappedData}
            tableLoading={source_data.is_table_loading}
            isFileUploading={isFileUploading}
            isPlaceholderFetching={isPlaceholderFetching}
            handleFileUpload={handleFileUpload}
          />
        )}

        {!source_data.is_initial &&
          (!source_data.is_table_loading ? (
            <>
              <EditableTableAttribute
                initWithoutHead
                page_props={page_props}
                sourceDropdownData={source_data.data.dropdown}
                defaultData={source_data.current_mapped_data}
                checkedRowCount={source_data.checked_rows_count}
                isFileUploading={isFileUploading}
                handleFileUpload={handleFileUpload}
                getData={getData}
                fieldsArr={fieldsArr}
                rowsPerPage={rowsPerPage}
                setIsEdit={setIsEdit}
                setGlobalEdit={setGlobalEdit}
                page={page}
                setPage={setPage}
                setRowsPerPage={setRowsPerPage}
                updateSourceHandler={handleSourceInput}
              />

              {/* Action button and disclaimer */}
              <div>
                <div className="disclaimer">
                  {/* RECOMMENDATION BUTTON */}
                  <div>
                    {source_data?.data?.dropdown?.recommendation_details
                      ?.is_recommendation &&
                      (source_data?.checked_rows_count ?? 0) > 1 && (
                        <Button
                          disableFocusRipple
                          style={containedButton}
                          onClick={handleModalopen}
                          // disabled={true}
                        >
                          Recommendations
                        </Button>
                      )}
                  </div>

                  {/* DISCLAIMER */}
                  <div>
                    {source_data?.data?.dropdown?.disclaimer_details
                      ?.is_Disclaimer_available &&
                      Array.isArray(
                        source_data?.data?.dropdown?.disclaimer_details
                          ?.disclaimer_text,
                      ) &&
                      source_data.data.dropdown.disclaimer_details
                        .disclaimer_text.length > 0 && (
                        <div style={{ display: "flex" }}>
                          <p
                            style={{
                              margin: "0px",
                            }}
                          >
                            Disclaimer:
                          </p>
                          <ul
                            style={{
                              listStyle:
                                source_data.data.dropdown.disclaimer_details
                                  .disclaimer_text.length > 1
                                  ? "outside"
                                  : "none",
                              margin: "0px",
                              marginLeft:
                                source_data.data.dropdown.disclaimer_details
                                  .disclaimer_text.length > 1
                                  ? "0px"
                                  : "-15px",
                            }}
                          >
                            {source_data.data.dropdown.disclaimer_details.disclaimer_text.map(
                              (text, idx) => (
                                <li key={idx}>{text}</li>
                              ),
                            )}
                          </ul>
                        </div>
                      )}
                  </div>
                </div>

                {/* ACTION BUTTONS */}
                <div className="action-buttons">
                  <div className="">
                    <Button
                      disableFocusRipple
                      variant="outlined"
                      style={outlinedCNCButton}
                      onClick={() => setIsBackDialogOpen(true)}
                      disabled={isTableDataSaving}
                    >
                      Back
                    </Button>
                    <Button
                      disableFocusRipple
                      variant="outlined"
                      style={outlinedCNCButton}
                      onClick={() => setIsCancelDialogOpen(true)}
                      disabled={isTableDataSaving}
                    >
                      Cancel
                    </Button>

                    {IS_ANY_RECORDS_EDITED && (
                      <Button
                        disableFocusRipple
                        style={containedButton}
                        onClick={handleDialogOpen}
                        disabled={isTableDataSaving}
                      >
                        <span>Save</span>
                      </Button>
                    )}
                  </div>
                </div>
              </div>

              {isRecommanded && (
                <RecommandationModal
                  actualData={source_data.current_mapped_data.filter(
                    (item) => item.isCheckedRow,
                  )}
                  closeModel={handleCloseModel}
                  openModel={isOpenModel}
                  selectClasses={{}}
                  inputClasses={{}}
                  updateSourceInputs={updateSourceInputs}
                  sourceData={source_data}
                  setGlobalEdit={setGlobalEdit}
                  user={user}
                  updateAlert={updateAlert}
                />
              )}

              {/* SAVE DIALOG */}
              <div>
                <Dialog
                  fullWidth={true}
                  maxWidth={"sm"}
                  open={isSaveDialogOpen}
                  onClose={handleDialogClose}
                >
                  <DialogTitle>{`${
                    source_data?.get_recommendation_for_all_rows &&
                    source_data?.get_recommendation_status === "In Progress"
                      ? "Caution"
                      : "Confirmation"
                  }`}</DialogTitle>
                  <DialogContent dividers>
                    <DialogContentText>
                      <p style={{ fontSize: "16px", color: "black" }}>
                        {`${
                          source_data?.get_recommendation_for_all_rows &&
                          source_data?.get_recommendation_status ===
                            "In Progress"
                            ? "Ai recommendations are In progress, Do you want to continue with the latest changes? "
                            : "The latest changes will be updated. Do you want to continue?"
                        }`}
                      </p>
                    </DialogContentText>
                  </DialogContent>
                  <DialogActions>
                    <Button
                      disableFocusRipple
                      variant="outlined"
                      style={outlinedCNCButton}
                      onClick={handleDialogClose}
                      disabled={isTableDataSaving}
                    >
                      Cancel
                    </Button>
                    <Button
                      disableFocusRipple
                      style={containedButton}
                      disabled={isTableDataSaving}
                      onClick={
                        source_data.has_awaiting_data.has_records
                          ? updateAwaitingData
                          : source_data?.data?.dropdown?.dimensions_with_approval?.includes(
                                source_data?.current_dimension?.value || "",
                              )
                            ? addAwaitingData
                            : onSave
                      }
                    >
                      Continue
                      {isTableDataSaving && <Loader />}
                    </Button>
                  </DialogActions>
                </Dialog>
              </div>

              {/* CANCEL DIALOG */}
              <div>
                <Dialog
                  fullWidth={true}
                  maxWidth={"sm"}
                  open={isCancelDialogOpen}
                  onClose={() => setIsCancelDialogOpen(false)}
                >
                  <DialogTitle>Confirmation</DialogTitle>
                  <DialogContent dividers>
                    <DialogContentText>
                      <p style={{ fontSize: "16px", color: "black" }}>
                        The latest changes will be undone. Do you want to
                        continue?
                      </p>
                    </DialogContentText>
                  </DialogContent>
                  <DialogActions>
                    <Button
                      disableFocusRipple
                      variant="outlined"
                      style={outlinedCNCButton}
                      onClick={() => setIsCancelDialogOpen(false)}
                    >
                      Cancel
                    </Button>
                    <Button
                      disableFocusRipple
                      style={containedButton}
                      onClick={cancelFunction}
                    >
                      Continue
                    </Button>
                  </DialogActions>
                </Dialog>
              </div>

              {/* BACK DIALOG */}
              <div>
                <Dialog
                  fullWidth={true}
                  maxWidth={"sm"}
                  open={isBackDialogOpen}
                  onClose={() => setIsBackDialogOpen(false)}
                >
                  <DialogTitle>Confirmation</DialogTitle>
                  <DialogContent dividers>
                    <DialogContentText>
                      <p style={{ fontSize: "16px", color: "black" }}>
                        The latest changes will be undone. Do you want to
                        continue?
                      </p>
                    </DialogContentText>
                  </DialogContent>
                  <DialogActions>
                    <Button
                      disableFocusRipple
                      variant="outlined"
                      style={outlinedCNCButton}
                      onClick={() => setIsBackDialogOpen(false)}
                    >
                      Cancel
                    </Button>
                    <Button
                      disableFocusRipple
                      style={containedButton}
                      onClick={goBackFunction}
                    >
                      Continue
                    </Button>
                  </DialogActions>
                </Dialog>
              </div>
            </>
          ) : (
            <Loader />
          ))}

        {/* DISCLAIMER BEFORE TABLE LOADING */}
        {can_show_initial_disclaimer && (
          <div className="disclaimer">
            <div>
              {source_data?.data?.dropdown?.disclaimer_details
                ?.is_Disclaimer_available &&
                Array.isArray(
                  source_data?.data?.dropdown?.disclaimer_details
                    ?.disclaimer_text,
                ) &&
                source_data.data.dropdown.disclaimer_details.disclaimer_text
                  .length > 0 && (
                  <div style={{ display: "flex" }}>
                    <p
                      style={{
                        margin: "0px",
                      }}
                    >
                      Disclaimer:
                    </p>
                    <ul
                      style={{
                        listStyle:
                          source_data.data.dropdown.disclaimer_details
                            .disclaimer_text.length > 1
                            ? "outside"
                            : "none",
                        margin: "0px",
                        marginLeft:
                          source_data.data.dropdown.disclaimer_details
                            .disclaimer_text.length > 1
                            ? "0px"
                            : "-15px",
                      }}
                    >
                      {source_data.data.dropdown.disclaimer_details.disclaimer_text.map(
                        (text, idx) => (
                          <li key={idx}>{text}</li>
                        ),
                      )}
                    </ul>
                  </div>
                )}
            </div>
          </div>
        )}

        {
          <DynamicDialog
            openModal={isDynamicDialogOpen}
            closeModel={handleDynamicDialogClose}
            title={"Confirmation"}
            hasCustomCancelButton={true}
            content={
              <p style={{ fontSize: "16px", color: "black", marginTop: "6px" }}>
                {dynamicDialogMessage}
              </p>
            }
            actions={
              <>
                <Button
                  onClick={handleDynamicDialogClose}
                  style={{
                    fontFamily: "Hind Siliguri",
                    fontSize: "12px",
                    fontWeight: "bold",
                    marginRight: "5px",
                  }}
                >
                  {source_data.has_awaiting_data.has_access ? "Cancel" : "Ok"}
                </Button>
                {source_data.has_awaiting_data.has_access && (
                  <Button
                    onClick={fetchAwaitingRecords}
                    style={{
                      backgroundColor: "#46596A",
                      fontFamily: "Hind Siliguri",
                      fontSize: "12px",
                      fontWeight: "bold",
                      marginRight: "5px",
                      color: "white",
                    }}
                  >
                    fetch
                  </Button>
                )}
              </>
            }
          />
        }
      </LayoutTopSideBottom>
    </>
  );
}
AttributeEnrichment.propTypes = {
  user: PropTypes.object,
  userData: PropTypes.object,
  source_data: PropTypes.object,
  brand_data: PropTypes.object,
  cncData: PropTypes.object,
  updateAlert: PropTypes.func,
  updateSourceInputs: PropTypes.func,
};

const mapStateToProps = (state) => ({
  user: state.user,
  cncData: state.cncinputs,
  source_data: state.source,
});

const mapDispatchToProps = {
  updateAlert,
  updateSourceInputs,
};
export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(AttributeEnrichment),
);
